import { RootState } from '@client/redux/types';
import { screenSizes } from '@lux/tokens';

const DEFAULT_DEVICE_WIDTH = 1200;
const DEFAULT_DEVICE_HEIGHT = 600;

export const getClientDevice = (state: RootState) => state.clientDevice;
export const getClientDeviceWidth = (state: RootState) =>
    state.clientDevice ? state.clientDevice.width : DEFAULT_DEVICE_WIDTH;
export const getClientDeviceHeight = (state: RootState) =>
    state.clientDevice ? state.clientDevice.height : DEFAULT_DEVICE_HEIGHT;
export const getClientDeviceOffsetTop = (state: RootState) => state.clientDevice.offsetTop;
export const getWebviewOs = (state: RootState) => state.clientDevice.webviewOs;
export const getIsMobileScreen = (state: RootState) => getClientDeviceWidth(state) < screenSizes.sm;
export const getTabVisible = (state: RootState) => state.clientDevice.tabVisible;
export const getWebviewTheme = (state: RootState) => state.clientDevice.webviewTheme;
